/**
 * Which §302 transport counter a `pt_gkv_billing_counter` row holds
 * (TM-9538 / #1520).
 *
 * ⚠ **Two kinds, never one.** They look alike — a running number per
 * communication partner, zero-padded on the wire — and A2-GGT says outright
 * that they are unrelated: *„Die Transfernummer hat keinen Bezug zur lfd. Nr.
 * des Vorlaufsatzes in den Nutzdaten."* They differ in key, in width and in the
 * value their cycle restarts at, so a row shared between them would wrap the
 * Datenaustauschreferenz every 999 files.
 *
 * ⚠ The two other counters of #1520 are **not** in here, on purpose:
 *
 * - The **Rechnungsnummer** runs on `pt_invoice_number_sequence` as the fourth
 *   series `gkv` — the same row lock, the same office grain, and the §14-UStG
 *   number range the Rechnungsstellung already owns.
 * - The **Verfahrensstand** per `(Leistungserbringer-IK × Kostenträger-IK)` is a
 *   *state*, not a counter: it holds whether a Kasse still treats that
 *   Leistungserbringer as in Erprobung, it never increments, and its
 *   Zustandstabelle is #1523's. Keyed here it would need a schema #1523 would
 *   then have to widen on a table with rows in it.
 */
export var GkvBillingCounterKind;
(function (GkvBillingCounterKind) {
    /** `UNB.0020`, per `(Absender, Empfänger)`. Five Stellen, wraps `99999 → 00001`. */
    GkvBillingCounterKind["DATENAUSTAUSCHREFERENZ"] = "datenaustauschreferenz";
    /** Auftragssatz Stellen 25–27, per Absender. Three Stellen, wraps `999 → 000`. */
    GkvBillingCounterKind["TRANSFER_NUMBER"] = "transfer_number";
})(GkvBillingCounterKind || (GkvBillingCounterKind = {}));
//# sourceMappingURL=gkv-billing-counter-kind.enum.js.map